export const TOKEN_KEY = 'jwt'

export const UserRole = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE',
  HR: 'HR'
};
